import React from 'react';
import './analytics.css';

/**
 * HeatmapChart - Day-of-week engagement heatmap
 *
 * Props:
 *   data       - Array of { day, dayIndex, engagement }
 *   title      - Chart title (optional)
 *   loading    - Show loading skeleton (optional)
 *   colorScale - { low, mid, high } hex colors (optional)
 */
export default function HeatmapChart({
  data = [],
  title,
  loading,
  colorScale = { low: '#e2e8f0', mid: '#93c5fd', high: '#2563eb' },
}) {
  if (loading) {
    return (
      <div className="an-chart-container">
        {title && <h4 className="an-chart-title">{title}</h4>}
        <div className="an-heatmap-skeleton" />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="an-chart-container">
        {title && <h4 className="an-chart-title">{title}</h4>}
        <div className="an-chart-empty" style={{ height: 100 }}>
          <span>No data available yet</span>
        </div>
      </div>
    );
  }

  const maxEngagement = Math.max(...data.map(d => d.engagement), 1);

  function getColor(value) {
    const ratio = value / maxEngagement;
    if (ratio === 0) return colorScale.low;
    if (ratio < 0.5) return colorScale.mid;
    return colorScale.high;
  }

  function getOpacity(value) {
    if (value === 0) return 0.3;
    return 0.4 + (value / maxEngagement) * 0.6;
  }

  return (
    <div className="an-chart-container">
      {title && <h4 className="an-chart-title">{title}</h4>}
      <div className="an-heatmap">
        {data.map((d) => (
          <div key={d.dayIndex} className="an-heatmap-cell-wrapper">
            <div
              className="an-heatmap-cell"
              style={{
                backgroundColor: getColor(d.engagement),
                opacity: getOpacity(d.engagement),
              }}
              title={`${d.day}: ${d.engagement} engagements`}
            >
              <span className="an-heatmap-count">{d.engagement}</span>
            </div>
            <span className="an-heatmap-day">{d.day.substring(0, 3)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
